<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">اسم الباقة - عربي:</label>
            <input type="text" v-model="title" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label english-input">:اسم الباقة - انجليزي</label>
            <input type="text" v-model="titleEn" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">وصف الباقة - عربي:</label>
            <textarea v-model="description" class="form-control" rows="3"></textarea>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label english-input">:وصف الباقة - انجليزي</label>
            <textarea v-model="descriptionEn" class="form-control" rows="3"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-3 mb-3">
            <label class="form-label">سعر الباقة (ر.س):</label>
            <input type="number" min="0" step="0.01" v-model.number="price" class="form-control">
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <label class="form-label">مدة الباقة (بالشهور):</label>
            <input type="number" min="1" max="120" step="1" v-model.number="durationMonths" class="form-control">
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <label class="form-label">عدد مرات الاستخدام:</label>
            <input type="number" min="0" step="1" v-model.number="visitsCount" class="form-control">
            <small class="text-muted">إجمالي عدد الزيارات المجانية المتاحة على الخدمات المشمولة</small>
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <label class="form-label">نسبة الخصم (%):</label>
            <input type="number" min="0" max="100" step="1" v-model.number="discountPercentage" class="form-control">
            <small class="text-muted">نسبة موحدة على الخدمات المحددة أدناه</small>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-12 mb-2">
            <h5 class="mb-3">الخدمات المشمولة بالباقة (استخدام مجاني)</h5>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div
                v-for="issue in issuesList" :key="`inc-${issue.id}`"
                class="col-12 col-sm-4 col-md-3 mb-2"
              >
                <div class="form-check">
                  <input
                    class="form-check-input" type="checkbox"
                    :id="`inc-${issue.id}`" :value="issue.id"
                    v-model="includedServices"
                    @change="removeFromDiscount(issue.id)"
                  >
                  <label class="form-check-label" :for="`inc-${issue.id}`">
                    {{ issue.name }}
                  </label>
                </div>
              </div>
              <div v-if="!issuesList.length" class="col"><p class="text-muted">لا توجد خدمات صيانة مفعلة</p></div>
            </div>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-12 mb-2">
            <h5 class="mb-3">الخدمات التي يطبق عليها الخصم</h5>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div
                v-for="issue in discountableIssues" :key="`dis-${issue.id}`"
                class="col-12 col-sm-4 col-md-3 mb-2"
              >
                <div class="form-check">
                  <input
                    class="form-check-input" type="checkbox"
                    :id="`dis-${issue.id}`" :value="issue.id"
                    v-model="discountServices"
                  >
                  <label class="form-check-label" :for="`dis-${issue.id}`">
                    {{ issue.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">المميزات المشمولة - عربي:</label>
            <div v-for="(item, indx) in features" :key="`ft-${indx}`" class="input-group mb-2">
              <input type="text" v-model="features[indx]" class="form-control">
              <button type="button" class="btn btn-danger" @click="removeFeature(indx)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            <button type="button" class="btn btn-light btn-sm" @click="addFeature()">
              <i class="bi bi-plus-circle me-1"></i> إضافة ميزة
            </button>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label english-input">المميزات المشمولة - انجليزي:</label>
            <div v-for="(item, indx) in featuresEn" :key="`fte-${indx}`" class="input-group mb-2">
              <input type="text" v-model="featuresEn[indx]" class="form-control">
              <button type="button" class="btn btn-danger" @click="removeFeatureEn(indx)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            <button type="button" class="btn btn-light btn-sm" @click="addFeatureEn()">
              <i class="bi bi-plus-circle me-1"></i> إضافة ميزة
            </button>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">الشروط والأحكام - عربي:</label>
            <textarea v-model="terms" class="form-control" rows="4"></textarea>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label english-input">:الشروط و الأحكام - انجليزي</label>
            <textarea v-model="termsEn" class="form-control" rows="4"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-4 mb-3">
            <label class="form-label">صورة الباقة:</label>
            <input type="file" class="form-control" accept="image/*" @change="setImage($event.target.files)">
            <div v-if="currentImage" class="mt-2">
              <img :src="MEDIA_URL+currentImage" class="img-thumbnail" alt="" style="max-height: 120px;">
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-3">
            <label class="form-label">ترتيب العرض:</label>
            <input type="number" v-model.number="sortNum" class="form-control">
          </div>
          <div class="col-12 col-sm-3 mb-3">
            <label class="form-label">الحالة:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div>

      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast } from '@/helpers/tools';

export default {
  name: 'MaintenancePackagesForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    issuesList: {
      type: Array,
      default: () => [],
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: null,
      titleEn: null,
      description: null,
      descriptionEn: null,
      price: 0,
      durationMonths: 12,
      visitsCount: 12,
      discountPercentage: 10,
      includedServices: [],
      discountServices: [],
      features: [],
      featuresEn: [],
      terms: null,
      termsEn: null,
      image: null,
      currentImage: null,
      sortNum: 0,
      isActive: true,
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL']),
    discountableIssues(){
      return this.issuesList.filter(issue => this.includedServices.indexOf(issue.id) == -1);
    },
  },
  methods: {
    removeFromDiscount(issueId){
      if(this.includedServices.indexOf(issueId) != -1){
        const indx = this.discountServices.indexOf(issueId);
        if(indx != -1)
          this.discountServices.splice(indx, 1);
      }
    },
    addFeature(){
      this.features.push('');
    },
    removeFeature(indx){
      this.features.splice(indx, 1);
    },
    addFeatureEn(){
      this.featuresEn.push('');
    },
    removeFeatureEn(indx){
      this.featuresEn.splice(indx, 1);
    },
    setImage(files){
      this.image = files[0];
    },
    validateForm(){
      if(!this.title || !this.titleEn){
        this.message = 'يجب ادخال اسم الباقة بالعربي والانجليزي';
        return false;
      }
      if(this.price === null || this.price === '' || this.price < 0){
        this.message = 'يجب ادخال سعر الباقة';
        return false;
      }
      const duration = Number(this.durationMonths);
      if(!Number.isInteger(duration) || duration < 1 || duration > 120){
        this.message = 'مدة الباقة يجب أن تكون عدداً صحيحاً من 1 إلى 120 شهر';
        return false;
      }
      const visits = Number(this.visitsCount);
      if(!Number.isInteger(visits) || visits < 0){
        this.message = 'عدد مرات الاستخدام يجب أن يكون صفراً أو عدداً صحيحاً موجباً';
        return false;
      }
      const discount = Number(this.discountPercentage);
      if(!Number.isInteger(discount) || discount < 0 || discount > 100){
        this.message = 'نسبة الخصم يجب أن تكون عدداً صحيحاً من 0 إلى 100';
        return false;
      }
      if(this.visitsCount > 0 && !this.includedServices.length){
        this.message = 'يجب تحديد الخدمات المشمولة بالباقة';
        return false;
      }
      if(this.discountPercentage > 0 && !this.discountServices.length){
        this.message = 'يجب تحديد الخدمات التي يطبق عليها الخصم';
        return false;
      }
      return true;
    },
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      if(!this.validateForm()){
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return;
      }

      const payload = {
        title: this.title,
        titleEn: this.titleEn,
        description: this.description,
        descriptionEn: this.descriptionEn,
        price: this.price,
        durationMonths: this.durationMonths,
        visitsCount: this.visitsCount,
        discountPercentage: this.discountPercentage,
        includedServices: this.includedServices,
        discountServices: this.discountServices,
        features: this.features.filter(item => item && item.trim() !== ''),
        featuresEn: this.featuresEn.filter(item => item && item.trim() !== ''),
        terms: this.terms,
        termsEn: this.termsEn,
        sortNum: this.sortNum ?? 0,
        isActive: this.isActive,
      };

      let requestData = payload;
      let config = {};
      if(this.image){
        const formData = new FormData();
        Object.keys(payload).forEach(key => {
          const value = payload[key];
          if(value === null || value === undefined)
            return;
          if(Array.isArray(value) || typeof value == 'object')
            formData.append(key, JSON.stringify(value));
          else
            formData.append(key, value);
        });
        formData.append('image', this.image);
        requestData = formData;
        config = {headers: {'Content-Type': 'multipart/form-data'}};
      }

      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/mPackages/update/${this.dataRow.id}`, requestData, config);
      else
        api = this.$http.post('/api/admin/mPackages/create', requestData, config);

      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الباقة بنجاح', 'success');
          this.$router.replace('/mPackages').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          if(data.row && data.row.image)
            this.currentImage = data.row.image;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.title = this.dataRow.title;
      this.titleEn = this.dataRow.titleEn;
      this.description = this.dataRow.description;
      this.descriptionEn = this.dataRow.descriptionEn;
      this.price = this.dataRow.price;
      this.durationMonths = this.dataRow.durationMonths;
      this.visitsCount = this.dataRow.visitsCount;
      this.discountPercentage = this.dataRow.discountPercentage;
      this.features = this.dataRow.features ? [...this.dataRow.features] : [];
      this.featuresEn = this.dataRow.featuresEn ? [...this.dataRow.featuresEn] : [];
      this.terms = this.dataRow.terms;
      this.termsEn = this.dataRow.termsEn;
      this.currentImage = this.dataRow.image;
      this.sortNum = this.dataRow.sortNum ?? 0;
      this.isActive = this.dataRow.isActive;

      const services = this.dataRow.MaintenancePackageIssues ?? [];
      services.forEach(item => {
        if(item.serviceType == 'included'){
          this.includedServices.push(item.issueId);
        }else{
          this.discountServices.push(item.issueId);
        }
      });
    }
  }
}
</script>